/*
 * @desc redux action combine
 * @author simbawu
 * @date 2018-11-08
 */

import ui from './ui';
import control from './control';
import exerciseCheck from './exerciseCheck';
import niceAudio from './niceAudio';
import rectify from './rectify';
import logoutReason from './logout';
import token from './token';
import gene from './gene';
import achievementMes from './achievement';

export default Object.assign(
  ui,
  control,
  exerciseCheck,
  niceAudio,
  rectify,
  logoutReason,
  token,
  gene,
  achievementMes
);
